import React from 'react';
import Login from './components/Login';
import {AuthenticatedTemplate, UnauthenticatedTemplate} from '@azure/msal-react';
import MarkexRoutes from './routes/MarkexRoutes';
import './App.css';


export default function App() {
  return (
    <>
        <AuthenticatedTemplate>
            <MarkexRoutes/>
        </AuthenticatedTemplate>
        <UnauthenticatedTemplate>
            <Login/>
        </UnauthenticatedTemplate>
    </>
  );
}
